import Message from "./Message.jsx";
import React from 'react';

/**
 * Class to display the text only message template.
 */
export default class TextMessageTemplate extends Message {
    render() {
        return (
            <div className={this.generateSenderClassName('text')}>
                {this.generateSenderMessage()}
                <div className="message-text" dangerouslySetInnerHTML={this.evaluateMarkdown(this.props.payload)} />
            </div>
        )
    }
}